import { API } from '@Providers';

export default async function (animalId: string) {
  const endpoint = `/api/shelter/animal-status-history/${animalId}`;

  return API({ endpoint });
}
